/**
 * live实例初始化
 * */
import { createLiveReact } from "@realsee/live";
import request from "../utils/request";
import { isMiniprogram, isApp } from '../utils/deviceDetect'
import {JSBridgeApp} from '@realsee/jsbridge-x/lib/app'
import { VRWebViewRTC } from "@realsee/live/lib/RTC/VRWebViewRTC";
import { BrowserRTC } from "@realsee/live/lib/RTC/BrowserRTC"
import { JSBridgeBrowser } from '../utils/browser'
import { JSBridgeMiniprogram } from '@realsee/jsbridge-x/lib/miniprogram'

const getVoiceSign = async (opts) => {
    return await request('getRtcSign', {
        voice_id: opts.voiceId,
        room_id: opts.roomId,
        user_id: opts.userId
    }).then((res) => {
        return {
            sdkAppId: Number(res.voice_app_id),
            userId: res.user_identifier,
            userSig: res.sign
        }
    }).catch((error) => {
        throw Error(error.message)
    })
}

let rtcInstance
if (isMiniprogram) {
    rtcInstance = new VRWebViewRTC({jsBridge: new JSBridgeMiniprogram(), getVoiceSign})
}
else if(isApp) {
    rtcInstance = new VRWebViewRTC({jsBridge: new JSBridgeApp(), getVoiceSign})
}
else {
    rtcInstance = new BrowserRTC({jsBridge: new JSBridgeBrowser(), getVoiceSign})
}


const liveInstance = createLiveReact({
    __debug__: true,
    rtc: rtcInstance
})

export default liveInstance


